<template>
  <div class='m-1 mb-5 mt-3' style=''>
    <b-overlay
      :show='loading'
      rounded
      opacity='0.6'
      spinner-small
      spinner-variant='primary'
      class='w-100'
    >
      <b-modal
        ref='delete-role'
        id='delete-role'
        scrollable
        size="xl"
        hide-footer
        title='Excluir cargo'
        header-bg-variant='danger'
        header-text-variant='light'
      >
        <section class='modal-font-family'>
          <b-overlay
            :show='loadingRoleHierarchies'
            rounded
            opacity='0.6'
            spinner-small
            spinner-variant='primary'
            class='w-100'
          >
            <p v-if="role && role.name">Excluir o cargo: <strong>{{role.name}}</strong></p>
            <section v-if="sectorsRoles && sectorsRoles.length > 0">
              <p class="mb-1">
                <strong>IMPORTANTE:</strong>
                <span class="ml-1">Ao excluir este cargo, todas as informações vinculadas a ele serão removidas da empresa na qual estão vinculadas.</span>
              </p>
              <strong>Isso inclui:</strong>
              <ul class="ml-3">
                <li>Setores associados a este cargo</li>
                <li>Produtos vinculados a esses setores</li>
                <li>Agentes relacionados a este cargo</li>
              </ul>
              <section
                class="d-flex flex-wrap sectors"
              >
                <section
                  class="mr-5 mb-4"
                  v-for="(sectorRole, i) in sectorsRoles"
                  :key="`${sectorRole._id}_${i}`"
                >
                  <p class="mb-1 sector-name">Setor: {{ sectorRole.sector.name }}</p>
                  <section
                    class="ml-3"
                    v-for="(role, indexSectorRole) in sectorRole.roles"
                    :key="`${role._id}_${indexSectorRole}`"
                  >
                    <section class="d-flex align-items-center">
                      <b-icon
                        class="mr-2"
                        icon="chevron-down"
                      >
                      </b-icon>
                      <p class="mb-1 role-name">Cargo: {{ role.name }}</p>
                    </section>
                    <section class="d-flex">
                      <section class="ml-2 line">

                      </section>
                      <section class="d-flex flex-column">
                        <section
                          class="ml-3"
                          v-for="(roleProductLegalConsultation, indexRoleProductLegalConsultation) in role.roleProductsLegalConsultation"
                          :key="`${roleProductLegalConsultation._id}_${indexRoleProductLegalConsultation}`"
                        >
                          <section
                            v-if="role.roleProductsLegalConsultation && role.roleProductsLegalConsultation.length > 0 && roleProductLegalConsultation.product">
                            <b-form-checkbox
                              v-model="isChecked"
                              disabled
                            >
                          <span
                            class="mb-1 product-name"
                          >
                            Produto: {{ roleProductLegalConsultation.product.name }}
                          </span>
                            </b-form-checkbox>
                          </section>
                        </section>
                      </section>
                    </section>
                  </section>
                </section>
              </section>
            </section>

            <section>
              <p class="mb-4" style="font-size: 18px"><strong>Essa ação é irreversível. Deseja continuar realmente com a exclusão?</strong></p>
            </section>


            <section class="d-flex w-100 justify-content-between">
              <b-button
                variant='outline-danger'
                class='w-50 mr-2'
                @click="hideModalDeleteRole()"
              >
                Cancelar
              </b-button>
              <b-button
                variant='success'
                class='w-50'
                @click="deleteRole()"
              >
                Excluir cargo
              </b-button>
            </section>

            <template v-slot:overlay>
              <div class='text-center loading-spinner'>
                <b-spinner
                  style='width: 3rem; height: 3rem'
                  variant='primary'
                  label='Large Spinner'
                ></b-spinner>
                <!--                <h5 class='text-primary'><strong>Buscando cargos...</strong></h5>-->
              </div>
            </template>
          </b-overlay>
        </section>
      </b-modal>
      <section class='mt-4 w-100 d-flex flex-column'>
        <label>Selecione a empresa</label>
        <b-input-group class="w-25">
          <b-form-select
            id='selectedCompany'
            v-model='filter.companyId'
            :options='companies'
            class='mb-3 w-100'
            style='height: 40px'
            value-field='_id'
            text-field='name'
            @change="setCompany()"
          >
          </b-form-select>
        </b-input-group>
      </section>

      <section>
        <base-table
          :columns='columns'
          :data='roles'
          :total-items='filter.total'
          :start-items='filter.skip + 1'
          :max-items='filter.limit'
          @set-page='setPagination'
        >
          <template v-slot:body-createdAt="row">
            {{ row.item && row.item.createdAt ? formatDate(row.item.createdAt) : '-' }}
          </template>

          <template v-slot:body-updatedAt="row">
            {{ row.item && row.item.updatedAt ? formatDate(row.item.updatedAt) : '-' }}
          </template>

          <template v-slot:body-company="row">
            {{ row.item && row.item.companyLegalConsultation && row.item.companyLegalConsultation.name ? row.item.companyLegalConsultation.name : '-'
            }}
          </template>

          <template v-slot:body-actions="row">
            <secion>
              <b-popover :target="`${row.item._id}_delete`" triggers="hover" placement="top">
                <template #title>Excluir cargo</template>
              </b-popover>

              <b-button
                :id="`${row.item._id}_delete`"
                variant="outline-danger"
                class='icon-transfer'
                @click="showModalDeleteRole(row.item)"
              >
                <b-icon icon='trash'></b-icon>
              </b-button>
            </secion>
          </template>

        </base-table>
      </section>
      <template v-slot:overlay>
        <div class='text-center loading-spinner'>
          <b-spinner
            style='width: 3rem; height: 3rem'
            variant='primary'
            label='Large Spinner'
          ></b-spinner>
          <h5 class='text-primary'><strong>Buscando cargos...</strong></h5>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { format } from 'date-fns'


export default {
  name: 'ManageRoles',
  components: {},
  data() {
    return {
      columns: [
        { key: '_id', value: 'ID' },
        { key: 'name', value: 'Nome' },
        { key: 'createdAt', value: 'Data do cadastro' },
        { key: 'updatedAt', value: 'Data da última atualização' },
        { key: 'company', value: 'Empresa' },
        { key: 'actions', value: 'Ação' }
      ],
      loading: false,
      loadingRoleHierarchies: false,
      isChecked: true,
      roles: [],
      role: Object,
      sectorsRoles: [],
      companies: [],
      filter: {
        companyId: null,
        userId: null,
        limit: 10,
        page: 1,
        skip: 0
      }
    }
  },
  created() {

  },

  async mounted() {
    try {
      await this.getPaginatedList()
      await this.getCompanies()
    } catch (e) {
    }
  },

  computed: {
    user() {
      return this.$store.getters['user/current']
    }
  },

  methods: {
    ...mapActions('role', {
      handleGetPaginatedList: 'handleGetPaginatedList',
      handleGetHierarchies: 'handleGetHierarchies',
      handleDeleteHierarchies: 'handleDeleteHierarchies',
    }),
    ...mapActions('companyLegalConsultation', {
      handleGetCompanyLegalConsultation: 'handleGetCompanyLegalConsultation'
    }),

    async getCompanies() {
      try {
        const { data } = await this.handleGetCompanyLegalConsultation(this.user.id)
        const { companies } = data
        this.companies = companies
        this.companies.unshift({ _id: null, name: 'Selecione a empresa' })
      } catch (e) {

      }
    },

    async showModalDeleteRole(role) {
      try {
        this.role = role
        const { _id } = role
        this.$bvModal.show('delete-role')
        this.loadingRoleHierarchies = true
        const { data: dataResponse } = await this.handleGetHierarchies(_id)
        const { data } = dataResponse
        this.sectorsRoles = data
        this.loadingRoleHierarchies = false
        console.log(data)
      } catch (e) {

      }
    },

    async hideModalDeleteRole(role) {
      try {
        this.$bvModal.hide('delete-role')
      } catch (e) {

      }
    },

    async deleteRole() {
      try {
        this.loadingRoleHierarchies = true
        const { data, status } = await this.handleDeleteHierarchies(this.role._id)
        let message = data.message
        let variant = 'success'
        if (status !== 200) {
          message = data.errors
          variant = 'danger'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.loadingRoleHierarchies = false
        await this.hideModalDeleteRole()
        await this.getPaginatedList()
      } catch (e) {

      }
    },

    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy: HH:mm:ss')
    },

    async setPagination(page) {
      try {
        this.filter.page = page
        await this.getPaginatedList()
      } catch (e) {

      }
    },

    async setCompany() {
      try {
        this.filter.page = 1
        await this.getPaginatedList()
      } catch (e) {

      }
    },

    async getPaginatedList() {
      try {
        this.loading = true
        this.filter.userId = this.user.id
        const { data } = await this.handleGetPaginatedList(this.filter)
        const { meta, items } = data
        this.filter = meta
        this.roles = items
        this.loading = false
      } catch (e) {

      }
    }
  }
}
</script>

<style lang='scss' scoped>
.sectors {
  .title {
    font-weight: 700;
    font-size: 17px;
    color: #262626;
  }

  .sector-name {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
  }

  .role-name {
    font-weight: 500;
    font-size: 15px;
    color: #000000;
  }

  .line {
    border-left: 1px solid #9C9C9C;
  }

  .product-name {
    font-weight: 400;
    font-size: 15px;
    color: #000000;
  }
}

</style>
